import { isBudgetCategory } from '@/types/budgets.types'

import type { BudgetFormSchema } from '@/components/BudgetForm/BudgetForm.types'

import {
  type BudgetData,
  category as BudgetCategory,
} from '@/__generated__/requests'

export function budgetFormDefaultValues(data?: BudgetData): BudgetFormSchema {
  return {
    category:
      data && isBudgetCategory(data?.category)
        ? data.category
        : BudgetCategory.OTHER,
    monthlyAmount: data?.monthlyAmount ?? 0,
  }
}
